import { Direction } from '@angular/cdk/bidi';
import { Overlay } from '@angular/cdk/overlay';
import { Component, Inject } from '@angular/core';
import { ModalService, POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { PopUpComponent } from '../pop-up.component';
import { CLOSE, REQUEST_SENT } from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-request-sent-pop-up',
    templateUrl: './request-sent-pop-up.component.html',
    styleUrl: './request-sent-pop-up.component.scss',
    standalone: false
})
export class RequestSentPopUpComponent extends PopUpComponent {
  closeText: string
  direction: Direction
  requestSentText: string

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,
    @Inject(POPUP_DATA) public data: any,
    private readonly modalService: ModalService,
    private readonly languageService: LanguageService
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.closeText = CLOSE[language.language]
      this.requestSentText = REQUEST_SENT[language.language]
    })
  }

  closePopup(): void {
    // Modal service handles the actual closing
    this.modalService.closePopUp();
  }
}
